export default "https://cdn-static.gokick.com/assets/f7932cbd9535e06fbf9353fcd5d5fd5cf044a6ff/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";